<template>
  <b-container fluid class="products">
    <b-row>
      <b-col style="padding: 0px;">
        <div class="text-center backgroundImg" v-bind:style="{background: 'url(' + getImage(bannerImg, 'banner') +')'}" >
          <div class="title-top text-uppercase">{{productTitleTop}}</div>
          <div class="title-middle text-uppercase primaryColor">{{productTitleMid}}</div>
          <center>
            <div class="title-bottom">
              {{productTitleBot}}
            </div>
          </center>
        </div>
      </b-col>
    </b-row>
    <!-- Product -->
    <b-row class="section1 p-5">
      <b-col lg="3" md="3" sm="12" xs="12" v-for="(product, index) in productList" :key="index">
        <div class="product mb-4">
          <div class="thumbnail">
            <img :src="getImage(product.attributes.image.data.attributes.url, 'url')">
          </div>
          <div class="name m-3">{{product.attributes.name}}</div>
          <div class="description">{{product.attributes.description}}</div>
          <!-- <div class="price">{{formatPrice(product.price)}} /{{product.unit}}</div> -->
        </div>
      </b-col>
      <b-col lg="12" v-if="productList != null & productList.data != null && productList.data.length < 1">
        Tidak ada produk yang tersedia saat ini
      </b-col>
    </b-row>
</b-container>
</template>

<script>
import util from '@/util'
import {mapGetters} from 'vuex'

export default {
  name: 'Products',
  data () {
    return {
      isLoading: false,
      isError: false,
      bannerImg: 'dsk-products-bg.jpg',
      productSection: 'products',
      productList: []
    }
  },
  methods: {
    getImage (imageName, section) {
      return util.getImage(imageName, section)
    },
    formatPrice (value) {
      return util.currencyFormat(value)
    },
    findAllProducts (page) {
      this.isLoading = true
      this.$store.dispatch('getProductList', {
        // data: {
        //   page: page,
        //   size: 100
        // },
        success: (res) => {
          this.$data.productList = res.body.data
        },
        fail: () => {
          this.toast('Could not get products. Try again later.', 'error', 'error_outline')
        }
      }).then(() => {
        this.isLoading = false
      }).catch(err => {
        console.error('error: ' + err)
      })
    },
    findContentById (id) {
      this.$data.isLoading = true
      this.$store.dispatch('findContentById', {
        data: {
          id: id
        },
        success: () => {
        },
        fail: () => {
          this.toast('Something went wrong. Try again later.', 'error', 'error_outline')
        }
      }).then(() => {
        this.$data.isLoading = false
      }).catch(err => {
        console.error('error: ' + err)
      })
    },
    findAllContents () {
      this.isLoading = true
      this.$store.dispatch('findAllContents', {
        success: (res) => {
        },
        fail: () => {
          this.toast('Could not get contents. Try again later.', 'error', 'error_outline')
        }
      }).then(() => {
        this.isLoading = false
      }).catch(err => {
        console.error('error: ' + err)
      })
    }
  },
  created () {
    this.findAllProducts(0)
    this.findAllContents()
    // this.findContentById('productTitleTop')
    // this.findContentById('productTitleMid')
    // this.findContentById('productTitleBot')
  },
  computed: {
    ...mapGetters([
      'productTitleTop', 'productTitleMid', 'productTitleBot'
    ])
  }
}
</script>

<style scoped>
.backgroundImg {
  background:
    linear-gradient(
      rgba(0, 0, 0, 0.75)
    ),
    url(../assets/dsk-products-bg.jpg) center top no-repeat;
  background-size: cover !important;
  min-height: 95vh;
  color: #fff;
}
.title-top {
  padding-top: 25vh;
  font-size: 1.2em;
}
.title-middle {
  padding-top: 50px;
  font-size: 2em;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-weight: bolder;
  letter-spacing: 5px;
}
.title-bottom {
  padding: 40px 10px 20px 10px;
  max-width: 950px;
  font-size: 1.2em;
}
.product {
  padding: 20px;
  background-color: #F2F2F2;
}
.thumbnail {
  max-height: 237px !important;
  max-width: 326px !important;
  background-color: #fff;
  overflow: hidden;
}
img {
  /* max-height: 100% !important; */
}
.name {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/Products.vue